import Basic from '@rebuild/materials/shared/home_wrapper/MenuBlock.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/home_wrapper/context';

function useSelfContext() {
	const getModuleBgMap = {};

	provideCurrentContext({
		getModuleBgMap
	});
}

export const componentMap = {
	basic: withProvider(Basic, useSelfContext)
};
